import React from 'react';
import { CheckedState } from '@radix-ui/react-checkbox';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../components/Common/UI/Select';
import { Input } from '../../../../../components/Common/UI/Input';
import Checkbox from '../../../../../components/Common/UI/Checkbox';
import { Button } from '../../../../../components/Common/UI/Button';
import { accountType, AccountTypeEnum } from '../index';

interface IAccountManagementFilters {
  selectedType: keyof typeof AccountTypeEnum;
  search: string;
  handleSearch: () => void;
  handleOnSelect: (payload: keyof typeof AccountTypeEnum) => void;
  handleOnChange: (payload: string) => void;
  handleCheckBox: (payload: CheckedState) => void;
}

function AccountManagementFilters({
  handleSearch,
  handleOnSelect,
  selectedType,
  handleOnChange,
  search,
  handleCheckBox,
}: IAccountManagementFilters) {
  return (
    <div className="flex gap-[20px] items-center py-[20px]">
      <Select onValueChange={e => handleOnSelect(e as keyof typeof AccountTypeEnum)} value={selectedType}>
        <SelectTrigger className="w-[300px]" label="Search Type">
          <SelectValue placeholder="Account Number" />
        </SelectTrigger>
        <SelectContent>
          {accountType.map(({ key, label }) => (
            <SelectItem key={key} value={key}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        className="w-[300px]"
        placeholder="Account Number"
        label="Seach Keyword"
        onChange={e => handleOnChange(e.target.value)}
        value={search}
        maxLength={75}
      />
      <div className="flex gap-2 items-center mt-[17px]">
        <Checkbox id="exactSearch" onCheckedChange={e => handleCheckBox(e)} />
        <label htmlFor="exactSearch" className="text-sm text-primary cursor-pointer">
          Exact Search
        </label>
      </div>
      <Button className="mt-[17px] ml-[15px]" onClick={handleSearch}>
        Search
      </Button>
    </div>
  );
}

export default AccountManagementFilters;
